import React, { useEffect, useState } from 'react'

import "./styles.scss"
import Button from '../Button'
import ModalResource from '../ModalResource'
import Card from '../Card/Card'
import { showToast, startLoading, stopLoading } from '../../services/common-service'
import { IframeMessageProxy } from 'iframe-message-proxy'
import IMPContainer from '../../constants/iframe-message-proxy-container';
import BlipPortalToastTypes from '../../constants/blip-portal-toast-types'
import Alert from '../Alert'
import { v4 as uuid } from 'uuid';
import ModalImportResource from '../ModalImportResource'

export default function ResourcesList({
    setResourceOpened,
    getResource
}) {
    const [resources, setResources] = useState([])
    const [isModalOpened, setIsModalOpened] = useState(null)
    const [isModalImportOpened, setIsModalImportOpened] = useState(null)

    const [alertOpened, setAlertOpened] = useState(false)
    const [alert, setAlert] = useState({})

    useEffect(() => {
        start()
    }, [])

    const getResourcesManagerPlugin = async () => {
        try {
            const result = await getResource("resourcesManagerPlugin", "resources")

            return result.resources
        } catch (error) {
            throw error
        }
    }

    const start = async () => {
        try {
            startLoading()

            let resourses = await getResourcesManagerPlugin()

            setResources(resourses)
        } catch (error) {
            console.error(error)
        } finally {
            stopLoading()
        }
    }


    const remove = async (_id) => {
        try {
            startLoading()

            let resourcesManagerPlugin = []

            try {
                const result = await IframeMessageProxy.sendMessage({
                    action: IMPContainer.Actions.SEND_COMMAND,
                    content: {
                        command: {
                            method: IMPContainer.CommandMethods.GET,
                            uri: "/resources/resourcesManagerPlugin",
                            // type: "application/json",
                            // resource: data
                        },
                        // destination: IMPContainer.Destinations.BLIP_SERVICE
                    }
                });

                resourcesManagerPlugin = result.response?.resources
            } catch (error) {
                if (typeof error == "string") {
                    error = JSON.parse(error)
                    if (error?.message && typeof error.message == "string")
                        error.message = JSON.parse(error.message)
                }

                console.log("error", error)

                if (error?.message?.reason?.code == 67) {
                    resourcesManagerPlugin = []
                } else
                    throw error
            }

            let newResourcesManagerPlugin = resourcesManagerPlugin.filter(resource => resource._id != _id)

            const result = await IframeMessageProxy.sendMessage({
                action: IMPContainer.Actions.SEND_COMMAND,
                content: {
                    command: {
                        method: IMPContainer.CommandMethods.SET,
                        uri: "/resources/resourcesManagerPlugin",
                        type: "application/json",
                        resource: { resources: newResourcesManagerPlugin }
                    },
                    // destination: IMPContainer.Destinations.BLIP_SERVICE
                }
            });

            setResources(newResourcesManagerPlugin)
        } catch (error) {
            // console.log(JSON.parse(error))
            // console.error(error)
            showToast({
                type: BlipPortalToastTypes.DANGER,
                message: error?.message || "Ocorreu um erro"
            });
        } finally {
            stopLoading()
            setAlertOpened(false)
        }
    }

    return (
        <>
            <div className="resources-list mt3 mb5">
                <div className="header mb3">
                    <h3>{resources.length > 0 ? `${resources.length} recurso${resources.length > 1 ? "s" : ""}` : ""}</h3>

                    <div style={{ display: 'flex', gap: 10 }}>
                        <Button
                            text="Importar"
                            variant="ghost"
                            arrow={false}
                            disabled={false}
                            onClick={() => setIsModalImportOpened(true)}
                        />

                        <Button
                            text="Cadastrar Recurso"
                            variant="primary"
                            arrow={false}
                            disabled={false}
                            onClick={() => setIsModalOpened({})}
                        />
                    </div>
                </div>

                {resources.length == 0 &&
                    <div style={{ textAlign: "center" }}>
                        <bds-typo variant="fs-20" bold="light">Nenhum recurso cadastrado até o momento</bds-typo>
                    </div>
                }

                <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                    {resources.map((resource, index) =>
                        <Card className="min-h-18" key={index}>
                            <div className="card-resource" style={{ display: "flex", justifyContent: "space-between" }}>
                                <div>
                                    <bds-typo variant="fs-20" bold="light" margin={false}>{resource.name}</bds-typo>
                                    <bds-typo variant="fs-16" bold="light">Chave: {resource.key}</bds-typo>
                                </div>
                                <div style={{ display: "flex", gap: 10 }}>
                                    <div className="none">
                                        <Button
                                            variant="ghost"
                                            icon="trash"
                                            arrow={false}
                                            disabled={false}
                                            onClick={() => {
                                                setAlertOpened(() => true)
                                                setAlert({
                                                    header: "Atenção!",
                                                    body: "Tem certeza que deseja deletar este item? Você não conseguirá recuperá-lo depois.",
                                                    actions: [
                                                        {
                                                            variant: "secondary",
                                                            bold: "true",
                                                            title: "Cancelar",
                                                            onClick: () => setAlertOpened(false)
                                                        },
                                                        {
                                                            variant: "primary",
                                                            bold: "true",
                                                            title: "Sim, tenho certeza",
                                                            onClick: async () => {
                                                                remove(resource._id)
                                                            }
                                                        }
                                                    ]
                                                })
                                            }}
                                            size="short"
                                        />
                                    </div>
                                    <div className="none">
                                        <Button
                                            variant="ghost"
                                            icon="copy"
                                            arrow={false}
                                            disabled={false}
                                            onClick={() => setIsModalOpened({
                                                ...resource,
                                                _id: uuid()
                                            })}
                                        />
                                    </div>
                                    <div className="none">
                                        <Button
                                            variant="ghost"
                                            icon="edit"
                                            arrow={false}
                                            disabled={false}
                                            onClick={() => setIsModalOpened(resource)}
                                        />
                                    </div>
                                    <div>
                                        <Button
                                            variant="ghost"
                                            text="Acessar dados"
                                            arrow={false}
                                            disabled={false}
                                            onClick={() => setResourceOpened(resource)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </Card>
                    )}
                </div>

                <ModalResource
                    opened={isModalOpened}
                    setOpened={setIsModalOpened}
                    getResourcesManagerPlugin={getResourcesManagerPlugin}
                    start={start}
                    getResource={getResource}
                />

                <ModalImportResource
                    opened={isModalImportOpened}
                    setOpened={setIsModalImportOpened}
                    start={start}
                    getResource={getResource}
                />
            </div>

            <Alert
                opened={alertOpened}
                setAlert={setAlert}
                {...alert}
            />
        </>
    )
}